import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareDotedBehindSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareDotedBehindSquare"><Path d="M12 2H8V6H10V4H12V2Z" fill="currentColor"/><Path d="M17 2H13V4H17V2Z" fill="currentColor"/><Path d="M22 2H18V4H20V6H22V2Z" fill="currentColor"/><Path d="M10 8V7H8V8H2V22H16V16H17V14H16V8H10Z" fill="currentColor"/><Path d="M22 11V7H20V11H22Z" fill="currentColor"/><Path d="M18 14V16H22V12H20V14H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareDotedBehindSquare;
